import React, { ReactNode, useEffect } from 'react'
import styled from 'styled-components'
import {createPortal} from 'react-dom'

export interface ModalProps {
	showModal: any;
	closeModal: any;
	openModal: any;
	children: ReactNode,
}

export const Modal = ({ children, showModal, openModal, closeModal }: ModalProps) => {
	useEffect(() => {
		function handleEscapeKey(event: KeyboardEvent) {
		  if (event.code === 'Escape') {
			closeModal()
		  }
		}
	  
		document.addEventListener('keydown', handleEscapeKey)
		return () => document.removeEventListener('keydown', handleEscapeKey)
	  }, [closeModal])

	if(showModal) {
		return createPortal(
			<div>
				<StyledModal>
					<ModalBody>
						<ModalClose onClick={closeModal}>
							<svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 24 24" enable-background="new 0 0 24 24" xmlSpace="preserve">
								<path d="M0.4395,23.56099C0.7325,23.854,1.1165,24,1.5005,24c0.383,0,0.767-0.146,1.06-0.43901 l9.44-9.4392l9.439,9.4392C21.7325,23.854,22.1165,24,22.5005,24c0.383,0,0.767-0.146,1.06-0.43901 c0.586-0.58501,0.586-1.53603,0-2.12104l-9.439-9.4402l9.439-9.4392c0.586-0.58501,0.586-1.53603,0-2.12104 c-0.586-0.58601-1.535-0.58601-2.121,0l-9.439,9.4392l-9.44-9.4392c-0.586-0.58601-1.535-0.58601-2.121,0 c-0.586,0.58501-0.586,1.53603,0,2.12104l9.439,9.4392l-9.439,9.4402C-0.1465,22.02496-0.1465,22.97598,0.4395,23.56099"></path>
							</svg>
						</ModalClose>
						<ModalContent>
							{children}
						</ModalContent>
					</ModalBody>
				</StyledModal>,
			</div>,
			document.getElementById('modal')!
		)
	} else return null;
}

const StyledModal = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	height: 100vh;
	width: 100vw;
	background-color: #fff;
	z-index: 1000;
	h1 {
		color: #311b92;
	}
	p, ol>li {
		font-size: 1.25rem;
	}
	p {
		line-height: 2rem;
	}
	ol>li{
		padding: 0.5rem;
	
	}
	hr {
		margin-top: 3rem;
		margin-bottom: 2rem;
	}
`

const ModalBody = styled.div`
	height: 100%;
	width: 100%;
	overflow: auto;
	margin-left: 2rem;
`

const ModalClose = styled.div`
	position: absolute;
    top: 2rem;
    right: 2rem;
    cursor: pointer;
	svg {
		height: 2rem;
		width: 2rem;
		fill: #33475b;
	}
`

const ModalContent = styled.div`
	width: 100%;
    max-width: 680px;
    margin: 0 auto 12rem;
    padding-top: 10rem;
	font-size: 1.5rem;
`

// const Overlay = styled.div`
// 	position: fixed;
// 	top: 0;
// 	left: 0;
// 	right: 0;
// 	bottom: 0;
// 	background-color: rgba(0,0,0, .3);
// 	z-index: 1;
// `